import React from 'react';
import { StyleSheet, Text, Pressable, View } from 'react-native';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import Hr from '../Hr';
import Icon from '../Icon';

const styles = StyleSheet.create({
    link: {
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'center',
        marginVertical: 1,
        height: 60
    },
    buttonText: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 20
    }
});

class CategoryLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { hasBottomDivider, title, style, onPress } = this.props;

        return (
            <Pressable
                style={[styles.link, style]}
                onPress={() => {
                    if (onPress) onPress();
                }}
            >
                <Hr style={{ marginVertical: 0 }} />
                <View
                    style={{
                        flexDirection: 'row',
                        alignSelf: 'stretch',
                        marginHorizontal: Theme.primaryMargin,
                        height: 60
                    }}
                >
                    <View style={{ flex: 1, justifyContent: 'center' }}>
                        <Text style={styles.buttonText}>{title}</Text>
                    </View>
                    <View style={{ justifyContent: 'center' }}>
                        <Icon style={{ width: 20, height: 20 }} name="arrow_right" />
                    </View>
                </View>
                {hasBottomDivider ? <Hr style={{ marginVertical: 0 }} /> : undefined}
            </Pressable>
        );
    }
}

CategoryLink.defaultProps = {
    onPress: () => {},
    hasBottomDivider: false,
    style: {}
};

CategoryLink.propTypes = {
    onPress: PropTypes.func,
    title: PropTypes.string.isRequired,
    hasBottomDivider: PropTypes.bool,
    style: PropTypes.shape({})
};

export default CategoryLink;
